import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { bumpIn } from '../../../styles/animations';

@Component({
  selector: 'app-button-picker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button-picker.component.html',
  styleUrls: ['./button-picker.component.scss'],
  animations: [bumpIn],
})
export class ButtonPickerComponent {
  @Input() options: number[] = [1, 2, 3, 4, 5];
  @Input() selectedOptions: number[] = [];
  @Input() buttonWidth: string = '42px';

  @Output() selectedEvent: EventEmitter<number[]> = new EventEmitter<number[]>();

  buttonState: { isPress: boolean } = { isPress: false };

  isSelect(value: number): boolean {
    return this.selectedOptions.includes(value);
  }

  onSelect(value: number): void {
    if (this.isSelect(value)) {
      this.selectedOptions = this.selectedOptions.filter((el) => el !== value);
    } else {
      this.selectedOptions = [...this.selectedOptions, value];
    }
    this.selectedEvent.emit(this.selectedOptions);
  }
}
